import React, { useState } from 'react' // Import useState
import { supabaseUrl, supabaseKey } from '../config.ts';
import { createClient } from '@supabase/supabase-js';

const supabase = createClient(supabaseUrl, supabaseKey);
const Contact = () => {
  // State for feedback popup
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [feedbackError, setFeedbackError] = useState(null);
  const [feedbackText, setFeedbackText] = useState('');
  const [feedbackRating, setFeedbackRating] = useState(0);

  // Function to close feedback popup
  const handleCloseFeedback = () => {
    setShowFeedbackPopup(false);
    setFeedbackSubmitted(false);
    setFeedbackError(null);
    setFeedbackText('');
    setFeedbackRating(0);
  };

  // Function to handle feedback submission (placeholder)

  const handleSubmitFeedback = async () => {
    setFeedbackError('');
    // If no text is provided AND the rating is still the default (5), prompt for input.
    // This encourages interaction but allows submitting just a rating or just text.
    if (!feedbackText.trim() && feedbackRating === 5) {
        setFeedbackError('Please provide some comments or adjust the rating.');
        return;
    }

    try {
        const { data, error } = await supabase
            .from('feedback')
            .insert([
                { comment: feedbackText, rating: feedbackRating }
            ]);

        if (error) {
            throw error;
        }

        setFeedbackSubmitted(true);
        // Optionally, close popup after a short delay or immediately
        setTimeout(() => {
            setShowFeedbackPopup(false);
            setFeedbackText('');
            setFeedbackRating(5);
            setFeedbackSubmitted(false);
        }, 1500); // Close after 1.5 seconds
    } catch (error) {
        console.error('Error submitting feedback:', error.message);
        setFeedbackError('Failed to submit feedback. Please try again.');
    }
};

  return (
    <>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <ul className="breadcrumb-animation">
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
          <li />
        </ul>
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h3 className="display-3 mb-4 wow fadeInDown" data-wow-delay="0.1s">
            Contact Us
          </h3>
          <ol
            className="breadcrumb justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          >
            <li className="breadcrumb-item">
              <a href="/">Home</a>
            </li>
            <li className="breadcrumb-item active text-primary">Contact</li>
          </ol>
        </div>
      </div>
      {/* Header End */}
      {/* Contact Start */}
      <div className="container-fluid contact pb-5">
        <div className="container pb-5">
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: 900 }}
          >
            <h4 className="text-primary mb-4">Contact Us</h4>
            <h1 className="display-5 mb-4">Get In Touch With Us</h1>
          </div>
          <div className="row g-5 align-items-center">
            <div className="col-lg-12 wow fadeInRight d-flex justify-content-between" data-wow-delay="0.3s">
              <div className="d-flex align-items-center mb-4">
                <div
                  className="bg-light d-flex align-items-center justify-content-center mb-3"
                  style={{ width: 90, height: 90, borderRadius: 50 }}
                >
                  <i className="fa fa-home fa-2x text-primary" />
                </div>
                <div className="ms-4">
                  <h4>Addresses</h4>
                  <p className="mb-0">
                    #1, Sri Thirumal Nager, Nadukuthagai, chennai - 602 024
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center mb-4">
                <div
                  className="bg-light d-flex align-items-center justify-content-center mb-3"
                  style={{ width: 90, height: 90, borderRadius: 50 }}
                >
                  <i className="fa fa-phone fa-2x text-primary" />
                </div>
                <div className="ms-4">
                  <h4>Mobile</h4>
                  <p className="mb-0">+91 91765 07631</p>
                  <p className="mb-0">+91 96000 98389</p>
                </div>
              </div>
              <div className="d-flex align-items-center mb-4">
                <div
                  className="bg-light d-flex align-items-center justify-content-center mb-3"
                  style={{ width: 90, height: 90, borderRadius: 50 }}
                >
                  <i className="fa fa-envelope-open fa-2x text-primary" />
                </div>
                <div className="ms-4">
                  <h4>Email</h4>
                  <p className="mb-0"> akconsultancy19@gmail.com</p>
                </div>
              </div>
              {/* Social Media Section - Uncommented and integrated */}
              <div className="d-flex align-items-center mb-4"> {/* Added mb-4 for consistent spacing */}
                <div className="me-4">
                  <div
                    className="bg-light d-flex align-items-center justify-content-center"
                    style={{ width: 90, height: 90, borderRadius: 50 }}
                  >
                    <i className="fas fa-share fa-2x text-primary" />
                  </div>
                </div>
                <div className="">
                  <a
                    className="btn btn-lg-square btn-primary rounded-circle me-2 mb-1"
                    href="" // Add actual Facebook link here
                  >
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a
                    className="btn btn-lg-square btn-primary rounded-circle mx-2  mb-1"
                    href="" // Add actual Twitter link here
                  >
                    <i className="fab fa-twitter" />
                  </a>
                  <a
                    className="btn btn-lg-square btn-primary rounded-circle mx-2  mb-1"
                    href="https://www.instagram.com/akconsultants?igsh=aHNxb2MyYXJ5M240" // Add actual Instagram link here
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-instagram" />
                  </a>
                  <a
                    className="btn btn-lg-square btn-primary rounded-circle mx-2  mb-1"
                    href="" // Add actual LinkedIn link here
                  >
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
            {/* New: Button to open feedback form */}
            <div className="col-12 text-center mt-5">
              <button className="btn btn-primary btn-lg" onClick={() => setShowFeedbackPopup(true)}>
                Provide Feedback
              </button>
            </div>
            <div className="col-12 wow fadeInUp" data-wow-delay="0.1s">
              <div className="rounded h-100">
                <iframe
                  className="rounded w-100"
                  style={{ height: 500 }}
                  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3885.4295887166268!2d80.04654307507921!3d13.135280587195314!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTPCsDA4JzA3LjAiTiA4MMKwMDInNTYuOCJF!5e0!3m2!1sen!2sin!4v1754322231637!5m2!1sen!2sin"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
            
          </div>
        </div>
      </div>
      {/* Contact End */}

      {/* Feedback Popup Modal */}
      {showFeedbackPopup && (
        <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
      )}
      {showFeedbackPopup && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content bg-light text-dark"> {/* Changed from bg-dark text-white */}
              <div className="modal-header border-bottom-0">
                <h5 className="modal-title">Provide Feedback</h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseFeedback}></button> {/* Changed from btn-close-white */}
              </div>
              <div className="modal-body">
                {!feedbackSubmitted ? (
                  <>
                    {feedbackError && <div className="alert alert-danger">{feedbackError}</div>}
                    <div className="mb-3">
                      <label htmlFor="feedbackText" className="form-label">Comments (Optional):</label>
                      <textarea
                        className="form-control bg-light text-dark border rounded-3 shadow-sm" // Styling remains appropriate
                        id="feedbackText"
                        rows="3"
                        value={feedbackText}
                        onChange={(e) => setFeedbackText(e.target.value)}
                        placeholder="Tell us what you think..."
                      ></textarea>
                    </div>
                    <div className="mb-3 text-center"> {/* Centered for star rating */}
                      <label className="form-label d-block mb-2">Rating:</label>
                      <div className="star-rating">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <span
                            key={star}
                            className="star"
                            style={{
                              cursor: 'pointer',
                              fontSize: '2rem', // Larger stars
                              color: star <= feedbackRating ? '#ffc107' : '#e4e5e9', // Gold for filled, light gray for empty
                              transition: 'color 0.2s ease-in-out', // Smooth transition
                            }}
                            onClick={() => setFeedbackRating(star)}
                          >
                            &#9733; {/* Unicode star character */}
                          </span>
                        ))}
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="text-center text-success">
                    <p className="mb-0">Thank you for your feedback!</p>
                  </div>
                )}
              </div>
              <div className="modal-footer border-top-0">
                {!feedbackSubmitted && (
                  <>
                    <button type="button" className="btn btn-secondary" onClick={handleCloseFeedback}>
                      Cancel
                    </button>
                    <button type="button" className="btn btn-primary" onClick={handleSubmitFeedback}>
                      Submit Feedback
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Contact